import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { DiaryEntry } from './DiaryEntry';
import { CtaButton } from './CtaButton';
export function DiarySection() {
  const entries = [{
    date: 'Vor 6 Monaten',
    title: 'Das Problem',
    content: <>
          Felix leckt seine Pfoten stundenlang. Zwischen den Zehen ist die Haut
          gerötet. Ich denke an Allergien, an Pilze, an Kontaktreizung. Ich
          kaufe Spezialshampoo. Nichts hilft dauerhaft. Der Tierarzt vermutet
          Futterallergie – wir wechseln das Futter. Keine Verbesserung.
        </>
  }, {
    date: 'Vor 4 Monaten',
    title: 'Der Wendepunkt',
    content: <>
          Ich lese einen Artikel: <strong data-id="element-45">Pfotenlecken</strong> kann ein Zeichen
          von <strong data-id="element-46">Darmproblemen</strong> sein. Der Darm-Haut-Achse. Ich bin
          skeptisch aber fasziniert. Ein gestörter Darm kann sich in
          Hautreizungen, Juckreiz und Pfotenlecken äußern. Das hat mir niemand
          erklärt. Ich hatte schon so viele Sachen ausprobiert — aber dann sah
          ich, dass fast 900 andere Hundehalter das Topping bewertet hatten,
          viele mit genau denselben Problemen wie Felix.
        </>
  }, {
    date: 'Vor 10 Wochen',
    title: 'Die Veränderung',
    content: <>
          Ich bestelle ein <strong data-id="element-47">pflanzliches Futtertopping</strong> für den
          Magen-Darm-Trakt. Nicht für die Haut – <strong data-id="element-48">für den Darm</strong>.
          Ich bin neugierig. Nach 2 Wochen: Felix leckt seltener. Nach 4 Wochen:
          die Rötung zwischen den Zehen geht zurück. Ich kann es kaum glauben.
        </>
  }, {
    date: 'Heute',
    title: 'Heute',
    content: <>
          Felix leckt seine Pfoten noch gelegentlich – aber nicht mehr obsessiv.
          Die Haut ist entspannt. Ich habe nie ein Hautprodukt gefunden das
          half. Die Lösung kam aus dem Darm.
        </>
  }];
  return <section className="w-full py-12 px-4 md:px-8 relative" data-id="element-49">
      {/* Subtle connecting line behind entries */}
      <div className="absolute left-1/2 top-0 bottom-0 w-px bg-warmBrown/10 -translate-x-1/2 hidden md:block" data-id="element-50"></div>

      <div className="max-w-4xl mx-auto" data-id="element-51">
        {entries.map((entry, index) => <Fragment key={index} data-id="element-52">
            <DiaryEntry entryNumber={index + 1} date={entry.date} title={entry.title} content={entry.content} data-id="element-53" />

            {/* Pull Quote after Entry 2 */}
            {index === 1 && <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="w-full max-w-2xl mx-auto my-16 text-center relative px-4" data-id="element-54">
                <span className="absolute -top-12 left-1/2 -translate-x-1/2 text-8xl font-serif text-warmBrown/20 leading-none select-none" data-id="element-55">
                  "
                </span>
                <p className="font-serif text-xl md:text-2xl text-gray-800 italic relative z-10" data-id="element-56">
                  Ich wollte doch einfach nur, dass es ihm besser geht.
                </p>
              </motion.div>}
          </Fragment>)}

        <div className="mt-12 flex justify-center" data-id="element-57">
          <CtaButton label="Das Topping das Felix geholfen hat → hier testen" position="story_cta" data-id="element-58" />
        </div>
      </div>
    </section>;
}